const FixtureGetSubscriptionsByIdInactivePayment = {
  success: {},
  payload: {
    subscription: {
      id: { id: "TEST-ID-PAYMENT-FAILURE" },
      user_id: { id: "5e0b13e5-aa4c-484d-97fe-de52eaff7177" },
      status: "INACTIVE",
      next_billing_date: null,
      last_billing_date: null,
      start_date: null,
      expiration_date: null,
      cancellation_cause: "PAYMENT_FAILURE",
      created_at: "2022-01-10T11:14:01.863710Z",
      updated_at: null,
      recurly_subscription_id: "a",
      stripe_subscription_id: "",
      activated_at: null,
      cancellation_date: null,
      device_sns: ["N1-605944818"],
      internal_id: { id: "00000000-0000-0000-0000-000000000000" },
      coupon_codes: [],
      subscription_quantity: 1,
      prepaid_period_days: 60,
      trial_period_days: 30,
      subscription_type: "STANDARD_SUBSCRIPTION",
    },
  },
};
export default FixtureGetSubscriptionsByIdInactivePayment;
